import { render, staticRenderFns } from "./BlockActions.vue?vue&type=template&id=7911ec81"
import script from "./BlockActions.vue?vue&type=script&lang=js"
export * from "./BlockActions.vue?vue&type=script&lang=js"
import style0 from "./BlockActions.vue?vue&type=style&index=0&id=7911ec81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports